import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    width: '100%',
    height: theme.settings.size.mobile.NonAuthMenuHeight,
    position: 'relative',
    zIndex: 100,
  },
}));



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/components/Menu/components/MobileMenu/useStyles.js